import { render, staticRenderFns } from "./MIndex.vue?vue&type=template&id=34512aa7&scoped=true&"
import script from "./MIndex.vue?vue&type=script&lang=js&"
export * from "./MIndex.vue?vue&type=script&lang=js&"
import style0 from "./MIndex.vue?vue&type=style&index=0&id=34512aa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34512aa7",
  null
  
)

export default component.exports